import { render, staticRenderFns } from "./EditProductImage.vue?vue&type=template&id=47f4b05b&scoped=true&"
import script from "./EditProductImage.vue?vue&type=script&lang=js&"
export * from "./EditProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4b05b",
  null
  
)

export default component.exports